import React, { useEffect } from 'react';
import ShopDetailsBreadcumb from '../components/shopdetails/ShopDetailsBreadcumb' 
import ShopDetailsArea from '../components/shopdetails/ShopDetailsArea'

function ShopDetailsPage() {
	useEffect(() => {
	  window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);
	
  return (
	  <main>
	  <ShopDetailsBreadcumb/>
	  <ShopDetailsArea/>
	  </main>
  )
}
export default ShopDetailsPage;
